import Avatar from '@component/avatar/Avatar';
import Box from '@component/Box';
import Card from '@component/Card';
import FlexBox from '@component/FlexBox';
import LazyImage from '@component/LazyImage';
import TextField from '@component/text-field/TextField';
import TextArea from '@component/textarea/TextArea';
import { useAppContext } from '@context/app/AppContext';
import { format } from 'date-fns';
import { Formik } from 'formik';
import _ from 'lodash';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { CartApi } from 'pages/api';
import AddressApi from 'pages/api/address';
import OrdersApi from 'pages/api/orders/orders';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import * as yup from 'yup';
import Button from '../buttons/Button';
import { Card1 } from '../Card1';
import Grid from '../grid/Grid';
import Select from '../Select';
import Typography, { H6, Paragraph } from '../Typography';

const CheckoutForm2 = () => {
  const router = useRouter();
  const { data: session, status } = useSession();
  const loading = status === 'loading';
  const { state, dispatch } = useAppContext();
  const { cartList } = state.cart;
  const token = session?.accessToken.toString();
  // const [hasVoucher, setHasVoucher] = useState(false);
  const [dateList, setDateList] = useState([]);
  const [bindingIds, setBindingIds] = useState(null);
  const [addressList, setAddressList] = useState([]);

  useEffect(() => {
    if (!router.query.bindingIds) {
      // NO BINDING IDS -> CREATE A CART -> GET CART
      getBindingIds();
    } else if (typeof router.query.bindingIds === 'string') {
      setBindingIds([router.query.bindingIds]);
    } else {
      setBindingIds(router.query.bindingIds);
    }
  }, [router]);

  const getBindingIds = async () => {
    await addItemsToCart();
    await getUserCart;
  };

  const addItemsToCart = async () => {
    cartList.forEach(async (item) => {
      try {
        const response = await CartApi.addToCart(token, item.id, item.qty);
        console.log('RESPONSE ADD ITEMS TO CART--->', response);
      } catch (error) {
        console.log('error in adding item to cart');
        toast.error('Oops, something went wrong.');
      }
    });
  };

  const getUserCart = async () => {
    try {
      const res = await CartApi.getCart(token);
      const { data } = res;
      const _bindingIds = data.map((item) => {
        return item.bindingId;
      });
      setBindingIds(_bindingIds);
    } catch (err) {
      console.log('ERROR getting user cart', err);
    }
  };

  const getUserAddresses = async () => {
    try {
      const resp = await AddressApi.getAddress(token);
      const { data } = resp;
      let _addArr = [];
      data.forEach((address) => {
        let _add = {
          addressType: address.title,
          address: address.addressLineOne + ' ' + address.addressLineTwo + ' ' + address.postalCode,
          buyerUserAddressId: address.id,
        };
        _addArr.push(_add);
      });
      setAddressList(_addArr);
    } catch (err) {
      console.log('error getting user addresses', err);
    }
  };

  useEffect(() => {
    if (!loading) {
      getUserAddresses();
      getUserCart();
    }
  }, [loading]);

  const handleFormSubmit = async (values) => {
    console.log('handleFormSubmit values', values);
    const { buyerUserAddressId, date, time, deliveryNotes } = values;
    try {
      const { status, data } = await OrdersApi.createOrder(
        token,
        bindingIds,
        buyerUserAddressId,
        format(date.value, 'yyyy-MM-dd'),
        time.value,
        deliveryNotes
      );
      toast.success('Order created successfully.', {
        position: 'top-center',
        style: { fontSize: '16px' },
      });
      router.push({ pathname: '/payment', query: { orderId: data.id } });
    } catch (error) {
      toast.error('Oops, something went wrong.');
      console.log('error creating order', error);
    }
  };

  const handleFieldValueChange = (value, fieldName, setFieldValue) => () => {
    setFieldValue(fieldName, value);
  };

  // const toggleHasVoucher = () => {
  //   setHasVoucher((has) => !has);
  // };

  useEffect(() => {
    let list = [];
    let today = new Date();
    let dateCount = today.getDate();

    list.push({
      label: format(today, 'dd MMMM'),
      value: today,
    });

    for (let i = 1; i < 10; i++) {
      today.setDate(dateCount + i);
      list.push({
        label: format(today, 'dd MMMM'),
        value: today,
      });
    }

    setDateList(list);
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      // validationSchema={checkoutSchema}
      onSubmit={handleFormSubmit}
    >
      {({ values, errors, touched, handleChange, handleSubmit, setFieldValue, handleBlur }) => (
        <form onSubmit={handleSubmit}>
          <Card1 mb="1.5rem">
            <FlexBox alignItems="center" mb="1.75rem">
              <Avatar bg="primary.main" size={32} color="primary.text" mr="0.875rem">
                2
              </Avatar>
              <Typography fontSize="20px">Delivery Details</Typography>
            </FlexBox>

            <Box mb="1.75rem">
              <Grid container spacing={6}>
                <Grid item sm={6} xs={12}>
                  <Select
                    label="Delivery Date"
                    options={dateList}
                    value={values.date || ''}
                    onChange={(date) => {
                      setFieldValue('date', date);
                    }}
                    errorText={touched.date && errors.date}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Select
                    label="Delivery Time"
                    options={timeList}
                    value={values.time || ''}
                    onChange={(time) => {
                      setFieldValue('time', time);
                    }}
                    errorText={touched.time && errors.time}
                  />
                </Grid>
              </Grid>
            </Box>

            <Typography mb="0.75rem">Delivery Address</Typography>
            <Grid container spacing={6}>
              {addressList.map((item, ind) => (
                <Grid item md={4} sm={6} xs={12} key={item.buyerUserAddressId}>
                  <Card
                    bg="gray.100"
                    p="1rem"
                    boxShadow="none"
                    border="1px solid"
                    cursor="pointer"
                    borderColor={
                      item.buyerUserAddressId === values.buyerUserAddressId
                        ? 'primary.main'
                        : 'transparent'
                    }
                    onClick={handleFieldValueChange(
                      item.buyerUserAddressId,
                      'buyerUserAddressId',
                      setFieldValue
                    )}
                  >
                    <H6 mb="0.25rem">{item.addressType}</H6>
                    <Paragraph color="gray.700">{item.address}</Paragraph>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Box mt="1.75rem">
              <Typography mb="0.75rem">Delivery Notes</Typography>
              <Grid container spacing={6}>
                <TextArea
                  name="deliveryNotes"
                  placeholder="Description"
                  rows={6}
                  fullwidth
                  style={{ margin: '0.5rem' }}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.deliveryNotes || ''}
                  errorText={touched.deliveryNotes && errors.deliveryNotes}
                />
              </Grid>
            </Box>
          </Card1>

          <Card1 mb="1.5rem">
            {/* <Paragraph
              className="cursor-pointer"
              color="primary.main"
              mt="1.5rem"
              lineHeight="1"
              onClick={toggleHasVoucher}
            >
              I have a voucher.
            </Paragraph>

            {hasVoucher && (
              <FlexBox mt="1.5rem" maxWidth="400px">
                <TextField
                  name="voucher"
                  placeholder="Enter voucher code here"
                  fullwidth
                  value={values.voucher || ''}
                  onChange={handleChange}
                />
                <Button variant="contained" color="primary" type="button" ml="1rem">
                  Apply
                </Button>
              </FlexBox>
            )}  */}

            <Button
              variant="contained"
              color="primary"
              mt="1.5rem"
              type="submit"
              fullwidth
              onSubmit={handleFormSubmit}
            >
              Place Order
            </Button>
          </Card1>
        </form>
      )}
    </Formik>
  );
};

const addressList = [
  {
    addressType: 'Home',
    address: '435 Bristol Avenue, Abington MA 2351',
  },
  {
    addressType: 'Office',
    address: '777 Brockton Avenue, Abington MA 2351',
  },
  {
    addressType: 'Office 2',
    address: '777 Kazi Avenue, Abington MA 2351',
  },
];

const contactList = [
  {
    contactType: 'Primary',
    contact: '+1-202-555-0119',
  },
  {
    contactType: 'Secondary',
    contact: '+1-202-555-0222',
  },
];

const paymentMethodList = [
  {
    cardType: 'Amex',
    last4Digits: '4765',
    name: 'Jaslynn Land',
  },
  {
    cardType: 'Mastercard',
    last4Digits: '5432',
    name: 'Jaslynn Land',
  },
  {
    cardType: 'Visa',
    last4Digits: '4543',
    name: 'Jaslynn Land',
  },
];

const timeList = [
  {
    label: '9AM - 11AM',
    value: '9AM - 11AM',
  },
  {
    label: '11AM - 1PM',
    value: '11AM - 1PM',
  },
  {
    label: '3PM - 5PM',
    value: '3PM - 5PM',
  },
  {
    label: '5PM - 7PM',
    value: '5PM - 7PM',
  },
];

const initialValues = {
  buyerUserAddressId: '',
  // card: '',
  date: '',
  time: '',
  deliveryNotes: '',
  // voucher: '',
};

const checkoutSchema = yup.object().shape({
  buyerUserAddressId: yup.number().required('required'),
  contact: yup.string().required('required'),
  // card: yup.string().required('required'),
  date: yup.object().required('required'),
  time: yup.object().required('required'),
  // voucher: yup.string(),
});

export default CheckoutForm2;
